import { l as o } from "./lodash-5ofSKtz3.mjs";
const i = [];
function r(s = 8) {
  let t = "";
  for (; t === "" || !o.includes(i, t); )
    t = (Math.random() + 1).toString(36).substr(2, s), i.push(t);
  for (; t.length < s; )
    t += r(s - t.length);
  return t;
}
export {
  r as m
};
//# sourceMappingURL=index-BGgjYpYz.mjs.map
